import { UrlConstants } from "../url.constants";
export class ApiPropertyAndLeaseConstants {
    static URL = UrlConstants.API_V2 + "PropertyAndLease";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetPropertyAndLeaseApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GeneratePropertyAndLeaseInvoiceReport";
    static FUNCTION_GET_LESSEES = "GetPlLessees";
    static FUNCTION_GET_BUYERS = "GetPlBuyers";
    static FUNCTION_GET_SELLERS = "GetPlSellers";
    static FUNCTION_SET_DETAILS = "SetPropertyAndLeaseDetails";
    static FUNCTION_SET_PROPERTIES = "SetPropertyAndLeaseProperties";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetPropertyAndLeaseRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
}
